import React from 'react';
import { Head } from '@medely/web-components';
import { isProduction } from 'utils/env';

const ChatGPTPixel = () => {
  if (!isProduction()) {
    return null;
  }

  return (
    <Head>
      <script id="chatgpt-pixel">
        {`
          !function(w,d,s,u){if(w.oaiq)return;var q=function(){q.q.push(arguments)};q.q=[];w.oaiq=q;var j=d.createElement(s);j.async=1;j.src=u;var f=d.getElementsByTagName(s)[0];f.parentNode.insertBefore(j,f)}(window,document,"script","https://bzrcdn.openai.com/sdk/oaiq.min.js");
          oaiq("init",{pixelId:"QNQDVtvqfos7spa7awjUVd",debug:true});
        `}
      </script>
    </Head>
  );
};

export default ChatGPTPixel;
